import useApi from '../useApi';

interface EncryptedChatResponse {
  status: string;
  key: string;
  msg?: string;
  data: {
    encryptedPrivateKey: string;
  
    salt: string;
    iv: string;
    [key: string]: any; 
  };
}

const useEncryptedChat = () => {
 
  const { loading: encryptedChatLoading, makeApiCall } = useApi({
    url: '/rtm/key',
    method: 'GET'
  });

  const getEncryptedChatKey = async (patientId: string) => {
    const overrideUrl = `/rtm/key?patientId=${patientId}`;
    
    try {
      const result = await makeApiCall<undefined, EncryptedChatResponse>(undefined, overrideUrl);
      
      if (result.response?.status === 'success') {
       
        return result.response;
      }

      console.error('Failed to get encrypted chat key:', result.error?.msg || 'Unknown error');
      return { status: 'fail' };
    } catch (error) {
      console.error('Error in getEncryptedChatKey:', error);
      return { status: 'fail' };
    }
  };

  return {
    encryptedChatLoading,
    getEncryptedChatKey,
  };
};

export default useEncryptedChat;